!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"));else if ("function" == typeof define && define.amd) define(["react"], t);else {
    var n = t("object" == typeof exports ? require("react") : e.React);
    for (var o in n) ("object" == typeof exports ? exports : e)[o] = n[o];
  }
}("undefined" != typeof self ? self : this, function (e) {
  return function (e) {
    function t(o) {
      if (n[o]) return n[o].exports;
      var a = n[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(a.exports, a, a.exports, t), a.l = !0, a.exports;
    }
    var n = {};
    return t.m = e, t.c = n, t.d = function (e, n, o) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: o
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 2);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    e.exports = n(3)();
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function a(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function r(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var l = function () {
        function e(e, t) {
          for (var n = 0; t.length > n; n++) {
            var o = t[n];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
          }
        }
        return function (t, n, o) {
          return n && e(t.prototype, n), o && e(t, o), t;
        };
      }(),
      i = n(0),
      u = o(i),
      c = n(1),
      f = o(c);
    n(7);
    var d = n(8),
      p = o(d),
      h = function (e) {
        function t(e) {
          a(this, t);
          var n = r(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
          return n.handleStartDrag = n.handleStartDrag.bind(n), n.handleDrag = n.handleDrag.bind(n), n.handleEndDrag = n.handleEndDrag.bind(n), n.handleEsc = n.handleEsc.bind(n), n.close = n.close.bind(n), n.open = n.open.bind(n), n.handleBackdropClick = n.handleBackdropClick.bind(n), n.hash = "" + Math.random(), n.state = {
            isOpen: e.isOpen || !1,
            isDragged: !1,
            x: null,
            y: null,
            deltaX: 0,
            deltaY: 0,
            mouseOffsetX: 0,
            mouseOffsetY: 0
          }, n;
        }
        return s(t, e), l(t, [{
          key: "componentDidMount",
          value: function value() {
            this.props.isOpen && this.setModalContext();
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(e) {
            "boolean" == typeof e.isOpen && this.props.isOpen !== e.isOpen && (e.isOpen ? this.open() : this.close());
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.unsetModalContext();
          }
        }, {
          key: "setModalContext",
          value: function value() {
            document.addEventListener("keydown", this.handleEsc), document.activeElement.blur(), document.body.classList.add("body-modal-fix");
          }
        }, {
          key: "handleEsc",
          value: function value(e) {
            var t = document.querySelectorAll(".pure-modal");
            if (t.length && !t[t.length - 1].classList.contains(this.hash)) return !1;
            void 0 === document.activeElement.value && 27 === e.keyCode && this.close(e);
          }
        }, {
          key: "unsetModalContext",
          value: function value() {
            document.removeEventListener("keydown", this.handleEsc), document.body.classList.remove("body-modal-fix"), this.setState({
              x: null,
              y: null,
              deltaX: 0,
              deltaY: 0,
              mouseOffsetX: 0,
              mouseOffsetY: 0
            });
          }
        }, {
          key: "getCoords",
          value: function value(e) {
            var t = e.pageX,
              n = e.pageY;
            return e.changedTouches && 1 === e.changedTouches.length && (t = e.changedTouches[0].pageX, n = e.changedTouches[0].pageY), {
              pageX: t,
              pageY: n
            };
          }
        }, {
          key: "handleStartDrag",
          value: function value(e) {
            if (e.changedTouches && e.changedTouches.length > 1) return !1;
            e.preventDefault();
            var t = this.getCoords(e),
              n = t.pageX,
              o = t.pageY,
              a = e.currentTarget.getBoundingClientRect(),
              r = a.top,
              s = a.left;
            return this.setState({
              isDragged: !0,
              x: "number" == typeof this.state.x ? this.state.x : s,
              y: "number" == typeof this.state.y ? this.state.y : r,
              mouseOffsetX: n - s,
              mouseOffsetY: o - r
            });
          }
        }, {
          key: "handleDrag",
          value: function value(e) {
            if (e.changedTouches && e.changedTouches.lenght > 1) return this.handleEndDrag();
            e.preventDefault();
            var t = this.getCoords(e);
            return this.setState({
              deltaX: t.pageX - this.state.x - this.state.mouseOffsetX,
              deltaY: t.pageY - this.state.y - this.state.mouseOffsetY
            });
          }
        }, {
          key: "handleEndDrag",
          value: function value() {
            return this.setState({
              isDragged: !1
            });
          }
        }, {
          key: "open",
          value: function value(e) {
            e && (e.stopPropagation(), e.preventDefault()), this.state.isOpen || (this.setState({
              isOpen: !0
            }), this.setModalContext());
          }
        }, {
          key: "close",
          value: function value(e) {
            if (e && (e.stopPropagation(), e.preventDefault()), this.state.isOpen) {
              var t = !1;
              this.props.onClose && e && (t = !this.props.onClose()), this.state.isOpen !== t && (this.setState({
                isOpen: t
              }), this.unsetModalContext());
            }
          }
        }, {
          key: "handleBackdropClick",
          value: function value(e) {
            if (e) {
              if (!e.target.classList.contains("pure-modal-backdrop")) return;
              e.stopPropagation(), e.preventDefault();
            }
            this.close(e);
          }
        }, {
          key: "render",
          value: function value() {
            if (!this.state.isOpen) return null;
            var e = this.props,
              t = e.children,
              n = e.replace,
              o = e.className,
              a = e.header,
              r = e.footer,
              s = e.scrollable,
              l = e.draggable,
              i = e.width,
              c = ["pure-modal-backdrop"],
              f = ["pure-modal", this.hash],
              d = ["panel-body"];
            return o && (f = f.concat(o)), s ? d = d.concat("scrollable") : (c = c.concat("scrollable"), f = f.concat("auto-height")), l && (c = c.concat("backdrop-overflow-hidden")), u.default.createElement("div", {
              className: c.join(" "),
              onClick: this.handleBackdropClick,
              onTouchMove: this.state.isDragged ? this.handleDrag : null,
              onMouseMove: this.state.isDragged ? this.handleDrag : null
            }, u.default.createElement("div", {
              className: f.join(" "),
              style: {
                transform: "translate(" + this.state.deltaX + "px, " + this.state.deltaY + "px)",
                transition: "none",
                width: i
              }
            }, u.default.createElement(p.default, {
              replace: n,
              header: a,
              footer: r,
              onDragStart: l ? this.handleStartDrag : null,
              onDragEnd: l ? this.handleEndDrag : null,
              onClose: this.close,
              bodyClass: d.join(" ")
            }, t)));
          }
        }]), t;
      }(u.default.Component);
    h.defaultProps = {
      mode: "modal",
      replace: !1,
      scrollable: !0,
      draggable: !1
    }, h.propTypes = {
      mode: f.default.oneOf(["modal", "tooltip"]),
      replace: f.default.bool,
      children: f.default.node,
      isOpen: f.default.bool,
      scrollable: f.default.bool,
      draggable: f.default.bool,
      onClose: f.default.func,
      className: f.default.string,
      width: f.default.string,
      header: f.default.oneOfType([f.default.node, f.default.string]),
      footer: f.default.oneOfType([f.default.node, f.default.string])
    }, t.default = h;
  }, function (e, t, n) {
    "use strict";

    var o = n(4),
      a = n(5),
      r = n(6);
    e.exports = function () {
      function e(e, t, n, o, s, l) {
        l !== r && a(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }
      function t() {
        return e;
      }
      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return n.checkPropTypes = o, n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return function () {
        return e;
      };
    }
    var a = function a() {};
    a.thatReturns = o, a.thatReturnsFalse = o(!1), a.thatReturnsTrue = o(!0), a.thatReturnsNull = o(null), a.thatReturnsThis = function () {
      return this;
    }, a.thatReturnsArgument = function (e) {
      return e;
    }, e.exports = a;
  }, function (e, t, n) {
    "use strict";

    function o(e, t, n, o, r, s, l, i) {
      if (a(t), !e) {
        var u;
        if (void 0 === t) u = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var c = [n, o, r, s, l, i],
            f = 0;
          u = Error(t.replace(/%s/g, function () {
            return c[f++];
          })), u.name = "Invariant Violation";
        }
        throw u.framesToPop = 1, u;
      }
    }
    var a = function a(e) {};
    e.exports = o;
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t) {}, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function a(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function r(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var l = function () {
        function e(e, t) {
          for (var n = 0; t.length > n; n++) {
            var o = t[n];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
          }
        }
        return function (t, n, o) {
          return n && e(t.prototype, n), o && e(t, o), t;
        };
      }(),
      i = n(0),
      u = o(i),
      c = n(1),
      f = o(c),
      d = function (e) {
        function t() {
          return a(this, t), r(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return s(t, e), l(t, [{
          key: "render",
          value: function value() {
            var e = this.props,
              t = e.children,
              n = e.replace,
              o = e.bodyClass,
              a = e.header,
              r = e.footer,
              s = e.onDragStart,
              l = e.onDragEnd,
              i = e.onClose;
            return n ? t : u.default.createElement("div", {
              className: "panel panel-default"
            }, u.default.createElement("div", {
              className: "panel-heading",
              onTouchStart: s,
              onMouseDown: s,
              onTouchEnd: l,
              onMouseUp: l
            }, a && u.default.createElement("h3", {
              className: "panel-title"
            }, a), u.default.createElement("div", {
              onClick: i,
              className: "close"
            }, "×")), u.default.createElement("div", {
              className: o
            }, t), r && u.default.createElement("div", {
              className: "panel-footer"
            }, r));
          }
        }]), t;
      }(u.default.PureComponent);
    d.defaultProps = {
      replace: !1,
      draggable: !1
    }, d.propTypes = {
      replace: f.default.bool,
      children: f.default.node,
      onDragStart: f.default.func,
      onDragEnd: f.default.func,
      onClose: f.default.func,
      bodyClass: f.default.string,
      header: f.default.oneOfType([f.default.node, f.default.string]),
      footer: f.default.oneOfType([f.default.node, f.default.string])
    }, t.default = d;
  }]);
});